<template>
  <div class="bf-banner">
    <h1 class="bf-banner__title">
      <b>
        <span>суперскидки</span> на все курсы
      </b>
    </h1>

    <p class="bf-banner__description">
      успейте забронировать обучение со скидкой <span>до 60%</span>
    </p>

    <div class="bf-banner__countdown">
      <div
        v-for="item of countdown"
        :key="item.id"
        class="bf-banner__countdown--item"
      >
        <p>
          {{ item.value }}
        </p>
        <span>
          {{ item.text }}
        </span>
      </div>
    </div>

    <button
      class="m-btn bf-banner__scroll"
      @click="scrollTo('.bf-cards')"
    >
      <img
        src="/v2/catalog-courses/banner/down.svg"
        alt="down"
      >
    </button>
  </div>
</template>

<script>
import scrollTo from '~/utils/scrollTo';
import getRemainingTime from '@/utils/remainingTime';

export default {
  name: 'BlackFridayBanner',
  data: () => ({
    remainingTime: {},
    interval: null,
  }),
  computed: {
    targetDate() {
      const today = new Date();

      const oddDate = Boolean(today.getDate() % 2);

      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + (oddDate ? 1 : 2));
      tomorrow.setHours(0, 0, 0, 0);

      return tomorrow;
    },
    countdown() {
      return [
        {
          value: this.remainingTime.days || '00',
          text: this.getDeclension(this.remainingTime.days, ['День', 'Дня', 'Дней']),
        },
        {
          value: this.remainingTime.hours || '00',
          text: this.getDeclension(this.remainingTime.hours, ['Час', 'Часа', 'Часов']),
        },
        {
          value: this.remainingTime.minutes || '00',
          text: this.getDeclension(this.remainingTime.minutes, ['Минута', 'Минуты', 'Минут']),
        },
        {
          value: this.remainingTime.seconds || '00',
          text: this.getDeclension(this.remainingTime.seconds, ['Секунда', 'Секунды', 'Секунд']),
        },
      ];
    },
  },
  beforeMount() {
    this.remainingTime = getRemainingTime(this.targetDate);

    this.interval = setInterval(() => {
      this.remainingTime = getRemainingTime(this.targetDate);
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    scrollTo,
    getDeclension(number, words) {
      const cases = [2, 0, 1, 1, 1, 2];
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    updateTime() {
      this.now = new Date();
    },
  },
};
</script>

<style lang="scss" scoped>
.bf-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(var(--scale) * 512);
  padding: calc(var(--scale) * 24) calc(var(--scale) * 40) calc(var(--scale) * 32);
  box-sizing: border-box;

  border-radius: calc(var(--scale) * 60);
  background-image: url("/v2/black-friday-24/banner/desktop-2.webp");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 360);
    padding: calc(var(--scale) * 20) calc(var(--scale) * 16);

    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/black-friday-24/banner/tablet-2.webp");
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 560);
    padding: calc(var(--scale) * 14);

    background-image: url("/v2/black-friday-24/banner/mobile-2.webp");
  }

  * {
    font-family: 'Onest', sans-serif;
  }

  .bf-banner__title {
    position: relative;
    max-width: calc(var(--scale) * 715);
    margin-bottom: calc(var(--scale) * 32);

    font-weight: 500;
    font-size: calc(var(--scale) * 120);
    line-height: 80%;
    letter-spacing: -0.06em;
    color: #7F1A0F;

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 16);
      max-width: calc(var(--scale) * 250);
      font-size: calc(var(--scale) * 44);
      letter-spacing: -0.07em;
    }

    span {
      color: #FFFFFF;
    }

    b {
      position: relative;
    }

    &:before {
      content: '';
      position: absolute;
      width: calc(var(--scale) * 706);
      height: calc(var(--scale) * 95);
      left: calc(-1 * var(--scale) * 7);
      top: calc(var(--scale) * 9);
      background-color: #FF5319;
      transform: rotate(-1deg);

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 252);
        height: calc(var(--scale) * 45);
        left: calc(-1 * var(--scale) * 3);
        top: calc(-1 * var(--scale) * 2);
      }
     }
  }

  .bf-banner__description {
    position: relative;
    max-width: calc(var(--scale) * 436);

    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: rgba(#7F1A0F, 0.3);

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 248);
      font-size: calc(var(--scale) * 18);
      line-height: 110%;
      letter-spacing: -0.02em;
    }

    &:before {
      content: '';
      position: absolute;
      width: calc(var(--scale) * 106);
      height: calc(var(--scale) * 36);
      left: calc(var(--scale) * 143);
      bottom: calc(-1 * var(--scale) * 3);
      background-color: #00A068;
      transform: rotate(-1deg);

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 67);
        height: calc(var(--scale) * 21);
        left: auto;
        right: 0;
        bottom: 0;
      }
    }

    span {
      color: #ffffff;
      position: relative;
    }
  }

  .bf-banner__countdown {
    margin-top: auto;
    display: flex;
    gap: calc(var(--scale) * 48);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 24);
    }

    @include media-down($size-mobile) {
      margin-top: calc(var(--scale) * 20);
      margin-left: calc(-1 * var(--scale) * 4);
    }

    &--item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-variant-numeric: tabular-nums;
      width: calc(var(--scale) * 120);

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 60);
      }

      p {
        font-weight: 600;
        font-size: calc(var(--scale) * 84);
        line-height: 110%;
        text-align: center;
        letter-spacing: -0.08em;
        text-transform: uppercase;
        color: #7F1A0F;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 42);
        }
      }

      span {
        margin-top: calc(-1 * var(--scale) * 8);
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        text-align: center;
        color: rgba(#7F1A0F, 0.3);

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 13);
          margin-top: calc(-1 * var(--scale) * 4);
        }
      }

      &:after {
        content: '';
        display: block;
        width: 1px;
        height: calc(var(--scale) * 60);
        position: absolute;
        top: calc(50% - var(--scale) * 30);
        right: calc(var(--scale) * -23.5);

        background-color: #7F1A0F;
        opacity: 0.3;

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 30);
          top: calc(50% - var(--scale) * 15);
          right: calc(var(--scale) * -11.5);
        }
      }

      &:last-of-type {
        &:after {
          content: none;
        }
      }
    }
  }

  &__scroll {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%) translateY(50%);
    width: calc(var(--scale) * 64);

    cursor: pointer;

    @include media-down($size-tablet) {
      display: none;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
